import React from "react";
import { SPECIFIC_CONTRACT_DICTIONARY } from "consts";
//
import { AutoSuggest } from "containers/components/autoSuggest";

const ContractAutoSuggest = (props) => {
    const suggestContract = (q) => {
        if (q) {
            q = q.toLocaleLowerCase();
        }

        return Promise.resolve(
            Object
                .keys(SPECIFIC_CONTRACT_DICTIONARY)
                .filter(key => (SPECIFIC_CONTRACT_DICTIONARY[key] || "")
                    .toLocaleLowerCase()
                    .includes(q)
                )
        )
    }

    return (
        <AutoSuggest
            label="Contract type"
            fetchOptions={suggestContract}
            renderOption={(key) => ({label: `${SPECIFIC_CONTRACT_DICTIONARY[key]}`, value: key})}
            optionIdentifier={(value) => value}
            {...props}
        />
    );
}

export default ContractAutoSuggest;
